import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PORTAL, usePortal } from '../portalAuth';
import { IMG } from '../components/StoreLayout';
import { STORE_BASE } from '../routeBase';

export default function Wishlist() {
  const { customer, wishlist, setWishlist, setCart, ready } = usePortal();
  const [busyId, setBusyId] = useState(null);

  if (!ready) return <div style={{ padding: 60, textAlign: 'center', color: '#aaa' }}>Loading…</div>;
  if (!customer) return (
    <div style={{ maxWidth: 500, margin: '60px auto', textAlign: 'center', padding: 20 }}>
      <i className="ti ti-heart" style={{ fontSize: 44, color: '#ddd' }} />
      <h2 style={{ marginTop: 12 }}>Please sign in to view your wish list</h2>
      <Link to={`${STORE_BASE}/login`} className={btnClass()} style={btn()}>Sign in</Link>
    </div>
  );

  const remove = async variantId => {
    setBusyId(variantId);
    const r = await PORTAL.delete(`/wishlist/${variantId}`);
    setWishlist(r.data);
    setBusyId(null);
  };
  const moveToCart = async variantId => {
    setBusyId(variantId);
    try {
      const r = await PORTAL.post('/cart', { variant_id: variantId, qty: 1 });
      setCart(r.data);
      const r2 = await PORTAL.delete(`/wishlist/${variantId}`);
      setWishlist(r2.data);
    } catch (e) { alert(e.response?.data?.error || 'Could not add to cart'); }
    setBusyId(null);
  };

  if (!wishlist.items.length) return (
    <div style={{ maxWidth: 500, margin: '60px auto', textAlign: 'center', padding: 20 }}>
      <i className="ti ti-heart" style={{ fontSize: 44, color: '#ddd' }} />
      <h2 style={{ marginTop: 12 }}>Your wish list is empty</h2>
      <p style={{ color: '#888', fontSize: 13.5, margin: '6px 0 0' }}>Tap the heart icon on any product to save it here.</p>
      <Link to={`${STORE_BASE}/shop`} className={btnClass()} style={btn()}>Browse products</Link>
    </div>
  );

  return (
    <div style={{ maxWidth: 900, margin: '24px auto', padding: '0 24px' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Wish List ({wishlist.count})</h1>
      <style>{`
        .sf-wl-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 14px; }
      `}</style>
      <div className="sf-wl-grid">
        {wishlist.items.map(it => (
          <div key={it.variant_id} style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
            <Link to={`${STORE_BASE}/product/${encodeURIComponent(it.model_no)}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div style={{ height: 140, background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {it.image ? <img src={IMG(it.image)} alt="" loading="lazy" style={{ maxWidth: '85%', maxHeight: '85%', objectFit: 'contain' }} /> : <i className="ti ti-eyeglass-2" style={{ color: '#ddd', fontSize: 34 }} />}
              </div>
              <div style={{ padding: '11px 13px 0' }}>
                <div style={{ fontWeight: 600, fontSize: 14.5 }}>{it.model_no}</div>
                <div style={{ fontSize: 11.5, color: '#888', margin: '2px 0 6px' }}>{[it.shape, it.material].filter(Boolean).join(' · ')}</div>
                {it.price != null && <div style={{ fontWeight: 700, color: 'var(--sf-primary)', fontSize: 14 }}>{wishlist.currency} {it.price}</div>}
              </div>
            </Link>
            <div style={{ display: 'flex', gap: 8, padding: 13 }}>
              <button onClick={() => moveToCart(it.variant_id)} disabled={busyId === it.variant_id} className="sf-btn-outline"
                style={{ flex: 1, border: '1.5px solid var(--sf-accent)', borderRadius: 20, padding: '8px 10px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
                <i className="ti ti-shopping-bag" /> Add to Cart
              </button>
              <button onClick={() => remove(it.variant_id)} disabled={busyId === it.variant_id} title="Remove"
                style={{ border: '1px solid #eee', background: '#fff', borderRadius: 20, width: 34, cursor: 'pointer', color: '#c0392b' }}>
                <i className="ti ti-trash" style={{ fontSize: 14 }} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const btn = () => ({ display: 'inline-block', marginTop: 18, padding: '10px 24px', borderRadius: 22,
  border: '1.5px solid var(--sf-accent)', textDecoration: 'none', fontSize: 14, fontWeight: 600 });
const btnClass = () => 'sf-btn-outline';
